import { Link } from "react-router-dom";
import ImmovoxLogo from "@/components/ImmovoxLogo";

const AdsFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary/50 py-12 border-t border-border/50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-2">
            <ImmovoxLogo size={24} className="text-primary" />
            <span className="text-xl font-semibold text-foreground">Immovox</span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <Link to="/mentions-legales" className="hover:text-primary transition-colors">Mentions légales</Link>
            <Link to="/cgu" className="hover:text-primary transition-colors">CGU</Link>
            <Link to="/confidentialite" className="hover:text-primary transition-colors">Confidentialité</Link>
            <Link to="/contact" className="hover:text-primary transition-colors">Contact</Link>
          </div>

          <p className="text-xs text-muted-foreground">
            © {currentYear} Immovox par KALYVOX SASU.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default AdsFooter;
